/**
 * Which tab the current path is on.
 *
 * Trailing-slash tolerant, and a prefix match for everything but the index.
 * `pathname === tab.to` left all three tabs unmarked for a URL ending in `/`,
 * and would do the same the first time one of them gains a child route.
 *
 * The index tab still has to match exactly: its path is a prefix of both
 * others, so a prefix match there would light it up on every tab.
 */
export function isTabActive(pathname: string, to: string, isIndex: boolean): boolean {
    const here = pathname.replace(/\/+$/, '');
    return isIndex ? here === to : here === to || here.startsWith(`${to}/`);
}
